/**
 * Created by danielr on 3/2/16.
 *
 * see the wiki page: https://lpgithub.dev.lprnd.net/security/lp-html-sanitizer
 *
 * ###### usage:
 *
 * $$$ AMD (with requirejs for instance)
 * var HtmlSanitizerUtils = require("HtmlSanitizerUtils");
 * var sanitizer = HtmlSanitizerUtils.sanitizeHtml(text); //text is the code you wish to sanitize
 *
 * $$$ NON-AMD (window global scope)
 * var sanitizer = window.lpTag.HtmlSanitizerUtils.sanitizeHtml(text); //text is the code you wish to sanitize
 *
 * ###### sanitizer output
 *
 * sanitizer.sanitized [boolean] true: malicious code found | false: no malicious code found
 * sanitizer.cleanText [string] the sanitized code to be used in case of sanitizer.sanitized is true
 * sanitizer.errors [array] the list of the sanitized issues found. Use this for validation summary.
 *
 * sanitizer.errors structure:
 * key: the element or the attribute value where the malicious code is targeted. example: onclick
 * type: the type of the malicious code (see the TYPES enum for the list of types). example: attribute
 * html: the original element html where the malicious code resides.  beware to escape the errors.html code in your validation summary first!
 *
 * example: <textarea class="ta request"></textarea><button onclick="alert();">click</button>
 * will ouput:
 * sanitizer.sanitized: true
 * sanitizer.cleanText: <textarea class="ta request"></textarea>
 * sanitizer.errors.key: "onclick"
 * sanitizer.errors.type: "attribute"
 * sanitizer.errors.html: <button onclick="alert();">click</button>
 *
 */
;(function (root, factory) {
    "use strict";

    //<amd>
    /* istanbul ignore next  */
    if ("function" === typeof define && define.amd) {
        // AMD. Register as an anonymous module.
        define("HtmlSanitizerUtils", function () {
            return factory(root, root);
        });
    }
    // LE-68611: VX asked the plugin to be always defined in lpTag
    // Browser globals
    root.lpTag = root.lpTag || {};
    factory(root, root.lpTag);
    //usage: window.lpTag.HtmlSanitizerUtils.sanitizeHtml(input);
}(this, function (root, exports) {
    var HtmlSanitizerUtils = (function(){
        "use strict";

        //the list of the html elements to be banned
        var BANNED_ELEMENTS = ["SCRIPT", "STYLE", "LINK", "IFRAME", "META", "OBJECT", "EMBED"];

        //the regex which scans all the attributes which starts with "on"
        var EVENT_ATTRIBUTES_REGEX = /^on\S+|^\S*[^A-Za-z]+on\S*/gi;

        //the regex which scans for banned attributes
        var BANNED_ATTRIBUTES_REGEX = /DIRNAME|SRCDOC|BEGIN|TO/gi;

        //the regex which scans for banned attributes values
        var BANNED_ATTRIBUTES_VALUE_REGEX = /DATA(\s*):|MHTML(\s*):|JAVASCRIPT(\s*):|EXPRESSION(\s*)\([^;]*\)/gi;

        //the regex which scans for banned attributes in style element
        var BANNED_STYLE_ATTRIBUTES_REGEX = /MHTML(\s*):([^;]*)|DATA(\s*):([^;]*)|MASK(\s*):([^;]*)|[\w]+(\s*):(\s*)EXPRESSION\([^;]*/gi;

        //the regex which scans for banned markers
        var BANNED_MARKERS_REGEX = /<\/\/(.*?)>|<[^ $€£A-Za-z0-9\/!](.*?)>/gi;

        //the regex which scans for elements that can not be identified as elements with the virtual DOM
        var NO_DOM_PARSING_ELEMENTS_REGEX = /<(\s*)?SCRIPT\b[^>]*(\s*)?>|<(\s*)?FRAMESET\b[^>]*(\s*)?>|<(\s*)?FRAME\b[^>]*(\s*)?>|<(\s*)?BODY\b[^>]*(\s*)?>/gi;

        //the regex which scans for malicious attributes that are executed asynchronously and not targeted with the virtual DOM. the attribute is: onerror, ontoggle, onload or onloadend (Firefox event)
        var SPECIAL_ATTRIBUTES_REGEX = /ONERROR(\s*)=(\s*)["']?((?:.(?!["']?\s+(?:\S+)=|[>"']))+.)["']?|ONLOAD(\s*)=(\s*)["']?((?:.(?!["']?\s+(?:\S+)=|[>"']))+.)["']?|ONTOGGLE(\s*)=(\s*)["']?((?:.(?!["']?\s+(?:\S+)=|[>"']))+.)["']?|ONRATECHANGE(\s*)=(\s*)["']?((?:.(?!["']?\s+(?:\S+)=|[>"']))+.)["']|ONLOADSTART(\s*)=(\s*)["']?((?:.(?!["']?\s+(?:\S+)=|[>"']))+.)["']?|ONLOADEND(\s*)=(\s*)["']?((?:.(?!["']?\s+(?:\S+)=|[>"']))+.)["']?/gi;

        //the regex which scans for square brackets marker
        var SQUARE_BRACKETS_REGEX = /\[.]/gi;

        //the regex which matches uris
        var URI_REGEX = /(((ftp|http|https):\/\/)|www[.])(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/gi;

        //the regex which matches emails - ref: vx email validation rule
        var EMAIL_REGEX = /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/gi;

        //the regex which scans for all opening tag elements
        var ALL_OPENING_TAGS = /<((\s)?[a-z%]+)\s*[^\/]*?/gi;

        //error.key const for elements that can not be identified as elements with the virtual DOM
        var NO_DOM_PARSING_ELEMENTS_KEY = "SCRIPT/FRAMESET/FRAME/BODY";

        //error.key const for special malicious attribute that can not be targeted by the virtual DOM
        var SPECIAL_ATTRIBUTES_KEY = "ONERROR_ONLOAD_ONTOGGLE_ONRATECHANGE_ONLOADEND";

        var TYPES = {
            ELEMENT: "element",
            ATTRIBUTE: "attribute",
            ATTRIBUTE_VALUE: "attribute_value",
            STYLE_ATTRIBUTE: "style_attribute",
            MARKER: "marker",
            NOT_WELLFORMED: "not_wellformed_html"
        };

        ////////////////////// PUBLIC METHODS /////////////////////

        /**
         * sanitizeHtml is the public method of the HtmlSanitizerUtils
         * @param text [string] the text to be sanitized
         * @returns {sanitized: boolean, cleanText: *, errors: Array}
         */
        function sanitizeHtml(text) {
            var originalCode = text;
            var errors = [];
            var cleanText = text;
            if (cleanText !== '') {
                cleanText = _deepDecodeText(cleanText);
            }

            /* ! do not change the order of the sanitizing steps ! */

            //sanitize banned markers
            var result = _sanitizeMarkers(cleanText);
            updateResult(result);

            //sanitize non parsable elements (script, frameset, frame, body)
            result = _sanitizeNonParsableElements(result.cleanText);
            updateResult(result);

            //sanitize special attributes (onerror)
            result = _sanitizeSpecialAttributes(result.cleanText);
            updateResult(result);

            //sanitize non wellformed tags
            result = _sanitizeNonWellFormedTags(result.cleanText);
            updateResult(result);

            //sanitize elements
            result = _sanitizeElements(result.cleanText);
            updateResult(result);

            //sanitize attributes
            result = _sanitizeAttributes(result.cleanText);
            updateResult(result);

            function updateResult(res) {
                if (res.errors.length > 0){
                    Array.prototype.push.apply(errors, res.errors);
                }
            }

            //output of the HtmlSanitizerUtils
            return {
                sanitized: errors.length > 0, //true if malicious code found
                cleanText: errors.length > 0 ? result.cleanText : originalCode, //the sanitized text
                errors: errors //list of errors found
            };
        }

        /**
         * formatLinks function is used in VX for bare links urls and emails.
         * it scans for any text which has a uri or email format and envelop them with the appropriate <a> tag
         * in order to make them linkable.
         * @param text  - the text to scan
         * @param options - [optional]: the regex to use to scan for emails or uris.
         * example: {
         * uri_regex: /any_uri_regex/g,
         * email_regex: /any_email_regex/g
         * }
         * @returns formatted text
         */
        function formatLinks(text, options){
            var uri_regex = (options && options.uri_regex && _isRegexValid(options.uri_regex)) ? options.uri_regex : URI_REGEX;
            var email_regex = (options && options.email_regex && _isRegexValid(options.email_regex)) ? options.email_regex : EMAIL_REGEX;

            var div = getVirtualDom(text);

            for (var k = 0; k < div.childNodes.length; k++){
                if (div.childNodes[k].nodeType === 3){//text type
                    div.childNodes[k].textContent = _convertTextToLink(div.childNodes[k].textContent, uri_regex, email_regex);
                }
                else {
                    //if the node has already a <a href occurrence we leave the text as is
                    var foundAnchorElement = div.childNodes[k].outerHTML.match(/<a\s+href/g);
                    if (!foundAnchorElement){
                        div.childNodes[k].innerText = _convertTextToLink(div.childNodes[k].innerText, uri_regex, email_regex);
                    }
                }
            }

            //we used textContent and innerText to wrap anchor. In order to make them html tags, we need to replace all the lt; and gt; to < and >
            div.innerHTML = div.innerHTML.replace(new RegExp("&lt;", "g"), "<").replace(new RegExp("&gt;", "g"), ">");
            return div.innerHTML;
        }

        /**
         * sanitizeAndCleanHtml will sanitize the text then apply the whitelist filter to clean the rest of the unsupported elements and attributes
         * @param text - text to sanitize and clean
         * @param allowedHtmlTagsAndAttributes - the allowed tags and attributes. example: {'DIV': ['ID', 'CLASS'], 'A': ['HREF', 'TARGET', 'ID']}
         * @returns {string} - sanitized and clean text
         */
        function sanitizeAndCleanHtml(text, allowedHtmlTagsAndAttributes){
            allowedHtmlTagsAndAttributes = allowedHtmlTagsAndAttributes || {};
            //first we normalize allowedHtmlTagsAndAttributes (structure and lower case of keys and values)
            allowedHtmlTagsAndAttributes = _normalizeWhiteListOptions(allowedHtmlTagsAndAttributes);

            //we first sanitize the text
            var sanitized = sanitizeHtml(text);
            var sanitizedText = sanitized.cleanText;
            var div = getVirtualDom(sanitizedText);
            var result = "";

            if (allowedHtmlTagsAndAttributes === {}) { //if normalizedWhiteListOptions is empty we just do not allow any html tag. we return the innerText
               result = div.innerText;
            }
            else { //clean the text according what is allowed
                _cleanTagAllChildren(div, allowedHtmlTagsAndAttributes);
                result = div.innerHTML;
            }
            return result;
        }

        ////////////////////// PRIVATE METHODS /////////////////////

        function getVirtualDom(code){
            var div = document.createElement("DIV");
            div.innerHTML = code;
            return div;
        }

        function _cleanTagAllChildren(node, allowedHtmlTagsAndAttributes){
            var childNodes = Array.prototype.slice.call(node.childNodes); //need to make a shallow copy of the array because we remove the elements in recursions.
            childNodes.forEach(function(node){
                if (node.hasChildNodes()){
                    _cleanTagAllChildren(node, allowedHtmlTagsAndAttributes);
                }
                if (node.nodeType !== 3) {//not a text type - valid dom element
                    var tagName = node.tagName.toLowerCase();
                    if (typeof allowedHtmlTagsAndAttributes[tagName] === "undefined"){ //not listed in the allowed tags and attributes
                        if (node.parentNode){ //we replace the whole tag html with its inner html code (the tag will not be renderred) - sice the recursion is starting from the end we pass over all the code and clean it any way
                            node.outerHTML = node.innerHTML;
                        }
                    }
                    else { // allowed tag - we check the tag's allowed attributes
                        var allowedAttributes = allowedHtmlTagsAndAttributes[tagName];
                        var attributesToRemove = [];
                        for (var j = 0; j < node.attributes.length; j++){
                            var nodeAttribute = node.attributes[j].name.toLowerCase();
                            if (allowedAttributes.indexOf(nodeAttribute) === -1){ //the node attribute is not in the allowed attributes list - we remove it
                                attributesToRemove.push(nodeAttribute);
                            }
                        }
                        for (var a = 0; a < attributesToRemove.length; a++){
                            node.removeAttribute(attributesToRemove[a]);
                        }
                    }
                }
            });
        }

        function _normalizeWhiteListOptions(allowedHtmlTagsAndAttributes){
            //normalize the structure and set all the keys and values to lower case
            var newAllowedHtmlAttributes = {};
            for (var tag in allowedHtmlTagsAndAttributes){
                var lowerCaseAttributes = [];
                if (allowedHtmlTagsAndAttributes[tag] instanceof Array){
                    lowerCaseAttributes = allowedHtmlTagsAndAttributes[tag].map(function(attribute){
                        attribute = attribute.toLowerCase();
                        return attribute;
                    });
                }
                newAllowedHtmlAttributes[tag.toLowerCase()] = lowerCaseAttributes;
            }
            return newAllowedHtmlAttributes;
        }

        /**
         * _deepDecodeText: the sanitizing process will start only when the code to check can not be decoded more.
         * it will decode itself recursively
         * @param text: the code to decode
         * @returns {string} the decoded code
         * @private
         */
        function _deepDecodeText(text) {
            var currentText = text;
            var decodedText = "";
            var failedToDecode = false;
            while (currentText !== decodedText) {
                try {
                    decodedText = decodeURIComponent(currentText);
                }
                catch (ex) {
                    //decodedText = currentText.replace("%", escape("%")); //wait for answer from Security Dept.
                    decodedText = currentText;
                    failedToDecode = true;
                }
                if (!failedToDecode) {
                    currentText = decodedText;
                }

            }

            return decodedText;
        }

        /**
         * _sanitizeElements: sanitize all elements found
         * @param text : code to sanitize
         * @returns {{errors: Array, cleanText: *}}
         * @private
         */
        function _sanitizeElements(text) {
            var result = {
                errors: [],
                cleanText: text
            };

            //we use the virtual DOM in order to parse all the elements
            var div = getVirtualDom(text);

            var textModified = false;
            for (var i = 0; i < BANNED_ELEMENTS.length; i++) {
                var elements = null;
                elements = div.getElementsByTagName(BANNED_ELEMENTS[i]);
                for (var j = 0; j < elements.length; j++) {
                    textModified = true;
                    result.errors.push({type: TYPES.ELEMENT, key: BANNED_ELEMENTS[i], html: elements[j].outerHTML});
                    var element = elements[j];
                    if (element && element.parentNode) {
                        element.parentNode.removeChild(element);
                    }
                }
            }

            if (textModified) {
                result.cleanText = div.innerHTML;
            }

            return result;

        }

        /**
         * _sanitizeAttributes: sanitize all the attributes found
         * @param text: code to sanitize
         * @returns {{errors: Array, cleanText: *}}
         * @private
         */
        function _sanitizeAttributes(text) {
            var result = {
                errors: [],
                cleanText: text
            };

            var resText = text;

            if (typeof resText !== 'string') {
                resText = resText.toString();
            }

            //we use virtual DOM in order to scan all the attributes
            var allAttributes = [];
            var div = getVirtualDom(resText);
            var allElements = div.getElementsByTagName("*");
            for (var k = 0; k < allElements.length; k++){
                for (var i = 0; i < allElements[k].attributes.length; i++){
                    allAttributes.push({attributeKey: allElements[k].attributes[i].name, attributeValue: allElements[k].attributes[i].value, element:allElements[k]});
                }
            }

            if (allAttributes) {
                //we loop over all the attributes and we scan in malicious attribute types found as well as malicious attribute values
                for (var a = 0; a < allAttributes.length; a++) {

                    var attributeKey = allAttributes[a].attributeKey;
                    var attributeValue = allAttributes[a].attributeValue;
                    var element = allAttributes[a].element;

                    //check for onXXX event attributes
                    _validateRegex(attributeKey, attributeValue, EVENT_ATTRIBUTES_REGEX, TYPES.ATTRIBUTE, element);

                    //check for banned attributes
                    _validateRegex(attributeKey, attributeValue, BANNED_ATTRIBUTES_REGEX, TYPES.ATTRIBUTE, element);

                    //check for banned attribute values
                    _validateRegex(attributeKey, attributeValue, BANNED_ATTRIBUTES_VALUE_REGEX, TYPES.ATTRIBUTE_VALUE, element);

                    //check for banned style attributes
                    if (attributeKey.toLowerCase() === "style") {
                        _validateRegex(attributeKey, attributeValue, BANNED_STYLE_ATTRIBUTES_REGEX, TYPES.STYLE_ATTRIBUTE, element);
                    }

                }
            }

            /**
             * _validateRegex: validates the code according a regex input
             * @param attributeKey : key attribute
             * @param attributeValue : value attribute
             * @param regExExpr : regular expression
             * @param attributeType : attribute type (one of the TYPES enum)
             * @param element : code context (tag element being tested)
             * @private
             */
            function _validateRegex(attributeKey, attributeValue, regExExpr, attributeType, element){
                var text = (attributeType === TYPES.STYLE_ATTRIBUTE || attributeType === TYPES.ATTRIBUTE_VALUE) ? attributeValue: attributeKey;

                //if we scan for attribute value we temporary remove [*] from the value and check if the resulted value is malicious. if no malicious we will place back the brackets
                //see https://html5sec.org/#101
                if (attributeType === TYPES.ATTRIBUTE_VALUE) {
                    text = text.replace(SQUARE_BRACKETS_REGEX,"");
                }
                var found = text.match(regExExpr);
                if (found){
                    //malicious code found
                    for (var i = 0; i < found.length; i++){
                        result.errors.push({
                            type: attributeType,
                            key: found[i],
                            html: element.outerHTML
                        });
                    }
                    //it has been decided with Security that the whole attribute will be removed even if one of the style property is malicious, the whole style will be removed
                    element.removeAttribute(attributeKey);
                }
            }

            result.cleanText = div.innerHTML;

            return result;
        }

        /**
         * _sanitizeNonWellFormedTags - non well formed tags can be an open gate to malicious code. example: <div onMouseOver=alert("fbff")
         * the virtual DOM does not know really how to handle non well formed tags and usually ignore them.
         * it has been decided that if such an use case occurs we set the errors type with the not_wellformed_html type and the cleanText just ignores the not well formed tag.
         * @param text : the code to test
         * @returns {{errors: Array, cleanText: *}}
         * @private
         */
        function _sanitizeNonWellFormedTags(text){
            var result = {
                errors: [],
                cleanText: text
            };

            var resText = text;

            if (typeof resText !== 'string') {
                resText = resText.toString();
            }
            //in order to know if the tags are wellformed or not we count the number of the opening tags in the code BEFORE using virtual DOM
            //then we use the virtual DOM and we count the number of opening tags of the resulting code
            //if the totals are different it means that the virtual DOM did not succeed to integrate all the tags obviously because they are not wellformed

            //calculate the total of opening tags before injecting the code in the virtual DOM
            var totalTagsBeforeCleaning = resText.match(ALL_OPENING_TAGS);
            totalTagsBeforeCleaning = (totalTagsBeforeCleaning === null) ? 0 : totalTagsBeforeCleaning.length;

            //inject the code in virtual DOM
            var div = getVirtualDom(resText);

            //calculate the total of opening tags after injecting the code in the virtual DOM
            var totalTagsAfterCleaning = div.innerHTML.match(ALL_OPENING_TAGS);
            totalTagsAfterCleaning = (totalTagsAfterCleaning === null) ? 0 : totalTagsAfterCleaning.length;

            //not wellformed error is outputted if the number of element tags after cleaning the code is less than the number of tags before cleaning it
            if (totalTagsAfterCleaning < totalTagsBeforeCleaning){
                result.errors.push({
                    type: TYPES.NOT_WELLFORMED,
                    key: "",
                    html: text
                });
            }

            result.cleanText = div.innerHTML;

            return result;
        }

        /**
         * _sanitizeMarkers: sanitize code from banned markers like <%%>
         * @param text : the code to sanitize
         * @returns {*}
         * @private
         */
        function _sanitizeMarkers(text) {
            //sanitize markers like <%%> [] <//
            var result = _regexOnlySanitize(text, BANNED_MARKERS_REGEX, TYPES.MARKER, "");
            return result;
        }

        /**
         * _sanitizeNonParsableElements: sanitize elements that are not parsable using the virtual DOM feature
         * @param text : code to sanitize
         * @returns {*}
         * @private
         */
        function _sanitizeNonParsableElements(text) {
            /*
             frameset and frame elements are not detectable in DOM parsing. same as script element if embedded in svg element
             body element is not always detectable in DOM parsing neither if embedded in other elements
             */
            var result = _regexOnlySanitize(text, NO_DOM_PARSING_ELEMENTS_REGEX, TYPES.ELEMENT, NO_DOM_PARSING_ELEMENTS_KEY);
            return result;
        }

        /**
         * _sanitizeSpecialAttributes: sanitize code from special attributes like onerror
         * @param text
         * @returns {*}
         * @private
         */
        function _sanitizeSpecialAttributes(text) {
            /*
             the onerror attribute with an alert value will popup the alert if I use the DOM parsing (append code in a new div).
             */
            var result = _regexOnlySanitize(text, SPECIAL_ATTRIBUTES_REGEX, TYPES.ATTRIBUTE, SPECIAL_ATTRIBUTES_KEY);
            return result;
        }

        /**
         * _regexOnlySanitize: this method is used to scan for a specific item in the code using regular expression only
         * we use this method for the few limitations we have with the use of virtual DOM code inject like the onerror attribute, body element, markers
         * @param text : the code to scan
         * @param regExExpr : the regular expression to apply the scan to
         * @param errorType : the error type if malicious code found
         * @param key : the error key if malicious code found
         * @returns {{errors: Array, cleanText: *}}
         * @private
         */
        function _regexOnlySanitize(text, regExExpr, errorType, key){
            var result = {
                errors: [],
                cleanText: text
            };

            var resText = text;

            if (typeof resText !== 'string') {
                resText = resText.toString();
            }

            var banned = resText.match(regExExpr);
            if (banned) {
                for (var i = 0; i < banned.length; i++) {
                    result.errors.push({
                        type: errorType,
                        key: key,
                        html: banned[i]});
                    resText = resText.replace(banned[i], "");
                }
            }

            result.cleanText = resText;

            return result;
        }

        function _isRegexValid(regExValue){
            return regExValue && regExValue.constructor === RegExp;
        }

        function _convertTextToLink(text, uri_regex, email_regex){
            text = _convertUri(text, uri_regex);
            text = text.replace(email_regex,"<a href='mailto:$&'>$&</a>");
            return text;
        }

        function _convertUri(text, uri_regex){//if www.xxx.com found then make the href attribute value to http://xxx.com (without www, so that the remote server will decide to redirect either to the http either to the https)
            text = text.replace(uri_regex, function(match, contents, offset, s){
                var foundWwwRelativeLink = match.match(/^www\./i);
                var hrefValue = foundWwwRelativeLink ? "http://" + match.replace(/www\./i, "") : match;
                return "<a href='" + hrefValue + "'>" + match + "</a>";
            });
            return text;
        }

        //the public methods we expose
        return {
            sanitizeHtml: sanitizeHtml,
            formatLinks: formatLinks,
            sanitizeAndCleanHtml: sanitizeAndCleanHtml
        };
    })();

    exports.HtmlSanitizerUtils = exports.HtmlSanitizerUtils || HtmlSanitizerUtils;

    return HtmlSanitizerUtils;
}));
